/* ============================================================
   TRENDING ORDER (trending.js) — GENERATED FILE
   ------------------------------------------------------------
   Controls the order of the Trending tab (the site's default
   feed). Items listed here appear first, in this order; anything
   not listed follows in Feed Script (sheet) order. Gated
   (Backstage) content never appears in Trending.

   HOW THIS GETS UPDATED
   The intent is a scheduled refresh: a Claude session gathers
   real engagement signals for Obed's content across platforms
   (YouTube view velocity, IG Reels, TikTok), scores each feed
   item with tools/rank_trending.py, regenerates this file, and
   redeploys. See ROADMAP.md → "Trend-weighted main feed."

   ⚠ CURRENT STATUS: the order below is an EDITORIAL SEED chosen
   by hand (official videos and flagship releases first) — NOT
   computed from measured data. Automated view-count collection
   was blocked at build time (YouTube rate-limits bots), so no
   numbers were invented. First real ranking run replaces this
   header with the signal data + date it was computed from.
   ============================================================ */

const TRENDING_UPDATED = '2026-09-02 (RANDOM mode — no pins, shuffled each visit, Shopify-hosted 3:1 over YouTube)';

/* PINNED OPENER — RETIRED (Benton, 2026-09-02): the feed now opens
   randomly, reshuffled on every visit, with Shopify-hosted clips
   prioritized 3:1 over YouTube (see feed.js trending assembly).
   To bring a scripted opener back, list item ids here in order —
   anything in this array leads the feed ahead of the shuffle.
   The previous progression, for reference:
   ['sh3', 'sh2', 'sh4', 'sh6', 'sh7']                             */
const TRENDING_PINNED = [];

const TRENDING_ORDER = [
  'sh3',      // newest short (Benton: first in feed) — retitle via the sheet
  'h1',       // Chicano Poetry live at The Observatory (HOSTED — store CDN)
  'h8',       // "What's your way?" vertical (HOSTED)
  'a-rc1',    // "RODEO CLOWN" — official video (newest EP title track)
  'h2',       // Alright OK crowd at The Observatory (HOSTED)
  'sh1',      // Rodeo Clown short (vertical — native feed format)
  'a-dyslm',  // "Do You Still Love Me?" — official video
  'sh2',      // Chicano Poetry short (vertical)
  'v1',       // "Changes"
  's5',       // DENM — "Slide Down" ft. Obed
  'v3',       // "Chicano Poetry" — Sendero Sessions
  's2',       // "Picture"
  'v6',       // "Broncos y Benzes" — Sendero Sessions
  's3',       // "Strung Out"
  's4',       // "Alright OK"
  'v8',       // On The Radar freestyle
  'ph1',      // tour photo dump
  'p3',       // vinyl
  'v2',       // tour announcement
  'p1',       // hoodie
];
